import { render, staticRenderFns } from "./StateWaitingForInformation.vue?vue&type=template&id=2893c1ad&scoped=true&lang=html&"
import script from "./StateWaitingForInformation.vue?vue&type=script&lang=coffee&"
export * from "./StateWaitingForInformation.vue?vue&type=script&lang=coffee&"
import style0 from "./StateWaitingForInformation.vue?vue&type=style&index=0&id=2893c1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893c1ad",
  null
  
)

component.options.__file = "StateWaitingForInformation.vue"
export default component.exports